function convertYearToWeek(num) {
  let eq = "Converting " + num + " year to week: \n" + num + " * 52.1775 = ";
  let rep = num * 52.1775;
  return eq + rep.toFixed(3);
}

function convertYearToSecond(num) {
  let eq =
    "Converting " + num + " year to second: \n" + num + " * 31556952= ";
  let rep = num * 31556952;
  return eq + rep.toFixed(2);
}

function convertYearToMonth(num) {
  let eq =
    "Converting " +
    num +
    " year to month: \n" +
    num +
    " * 12 = ";
  let rep = num * 12;
  return eq + rep.toFixed(2);
}

function convertYearToMinute(num) {
  let eq =
    "Converting " +
    num +
    " year to minute: \n" +
    num +
    " * 525949.2 = ";
  let rep = num * 525949.2;
  return eq + rep.toFixed(3);
}

function convertYearToHour(num) {
  let eq =
    "Converting " +
    num +
    " year to hour: \n" +
    num + " * 8765.82 = ";
  let rep = num * 8765.82;
  return eq + rep.toFixed(3);
}

function convertYearToDay(num) {
  let eq =
    "Converting " + num + " year to day: \n" + num + " * 365.2425 = ";
  let rep = num * 365.2425;
  return eq + rep.toFixed(3);
}

export {
  convertYearToDay,
  convertYearToHour,
  convertYearToMinute,
  convertYearToMonth,
  convertYearToSecond,
  convertYearToWeek
};
